import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import { get } from 'lodash';

type handleFunction = (...args: any) => any;

interface ButtonProps {
  title: string;
  onClick: handleFunction | null;
}

export interface DialogProps {
  title: string;
  body: string;
  footer: {
    reject: ButtonProps;
    existingResolve: ButtonProps;
    importedResolve: ButtonProps;
  };
}

@Component
export default class ErrorDialog extends Vue {
  @Prop() errorProps: DialogProps;
  @VModel() visible: boolean;

  private readonly footerPath = 'footer.';
  private readonly PATH = {
    reject: 'reject',
    existingResolve: 'existingResolve',
    importedResolve: 'importedResolve'
  };

  get title(): string {
    return this.errorProps.title || '';
  }

  get body(): string {
    return this.errorProps.body || '';
  }

  hasButton(path: string): boolean {
    const buttonProp = get(this.errorProps, this.footerPath + path, null);
    return buttonProp !== null;
  }
}
